import { httpClient } from '../utils/httpClient';
import {
  TarifaAnual, TarifaAnualPayload,
  TipoDescuento, TipoDescuentoPayload,
  PagoMatricula, PagarPayload,
  Pension,
  EstadoCuenta,
  DescuentoEstudiante, DescuentoEstudiantePayload,
} from '../types/pago.types';

// ============================================================
// pagoService.ts – Servicios del módulo de pagos
// ============================================================

// ── TarifaAnual ───────────────────────────────────────────────

export const tarifaService = {

  async listar(anioEscolarId?: number): Promise<TarifaAnual[]> {
    const qs = anioEscolarId ? `?anioEscolarId=${anioEscolarId}` : '';
    return httpClient.get<TarifaAnual[]>(`/tarifas-anuales${qs}`);
  },

  async crear(payload: TarifaAnualPayload): Promise<TarifaAnual> {
    return httpClient.post<TarifaAnual>('/tarifas-anuales', payload);
  },

  async modificar(idTarifa: number, payload: TarifaAnualPayload): Promise<TarifaAnual> {
    return httpClient.put<TarifaAnual>(`/tarifas-anuales/${idTarifa}`, payload);
  },

  async eliminar(idTarifa: number): Promise<void> {
    return httpClient.delete<void>(`/tarifas-anuales/${idTarifa}`);
  },
};

// ── TipoDescuento ─────────────────────────────────────────────

export const tipoDescuentoService = {

  async listar(): Promise<TipoDescuento[]> {
    return httpClient.get<TipoDescuento[]>('/tipos-descuento');
  },

  async crear(payload: TipoDescuentoPayload): Promise<TipoDescuento> {
    return httpClient.post<TipoDescuento>('/tipos-descuento', payload);
  },

  async modificar(id: number, payload: TipoDescuentoPayload): Promise<TipoDescuento> {
    return httpClient.put<TipoDescuento>(`/tipos-descuento/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/tipos-descuento/${id}`);
  },
};

// ── PagoMatricula ─────────────────────────────────────────────

export const pagoMatriculaService = {

  async listar(params: { estudianteId?: number; anioEscolarId?: number; estado?: string } = {}): Promise<PagoMatricula[]> {
    const q = new URLSearchParams();
    if (params.estudianteId)  q.set('estudianteId',  String(params.estudianteId));
    if (params.anioEscolarId) q.set('anioEscolarId', String(params.anioEscolarId));
    if (params.estado)        q.set('estado',        params.estado);
    const qs = q.toString();
    return httpClient.get<PagoMatricula[]>(`/pagos-matricula${qs ? `?${qs}` : ''}`);
  },

  async pagar(estudianteId: number, anioEscolarId: number, payload: PagarPayload, idempotencyKey?: string): Promise<PagoMatricula> {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined;
    return httpClient.put<PagoMatricula>(
      `/estudiantes/${estudianteId}/estado-cuenta/pagar-matricula?anioEscolarId=${anioEscolarId}`,
      payload,
      headers ? { headers } : undefined,
    );
  },
};

// ── Pension ───────────────────────────────────────────────────

export const pensionService = {

  async listar(params: { estudianteId?: number; anioEscolarId?: number; estado?: string } = {}): Promise<Pension[]> {
    const q = new URLSearchParams();
    if (params.estudianteId)  q.set('estudianteId',  String(params.estudianteId));
    if (params.anioEscolarId) q.set('anioEscolarId', String(params.anioEscolarId));
    if (params.estado)        q.set('estado',        params.estado);
    const qs = q.toString();
    return httpClient.get<Pension[]>(`/pensiones${qs ? `?${qs}` : ''}`);
  },

  async reemitirComprobante(idPension: number): Promise<Pension> {
    return httpClient.post<Pension>(`/pensiones/${idPension}/reemitir-comprobante`, {});
  },

  async pagar(estudianteId: number, numeroPension: number, anioEscolarId: number, payload: PagarPayload, idempotencyKey?: string): Promise<Pension> {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined;
    return httpClient.put<Pension>(
      `/estudiantes/${estudianteId}/estado-cuenta/pagar-pension/${numeroPension}?anioEscolarId=${anioEscolarId}`,
      payload,
      headers ? { headers } : undefined,
    );
  },
};

// ── EstadoCuenta ──────────────────────────────────────────────

export const estadoCuentaService = {

  async getByEstudiante(estudianteId: number, anioEscolarId: number): Promise<EstadoCuenta> {
    return httpClient.get<EstadoCuenta>(
      `/estudiantes/${estudianteId}/estado-cuenta?anioEscolarId=${anioEscolarId}`
    );
  },
};

// ── DescuentoEstudiante ───────────────────────────────────────

export const descuentoEstudianteService = {

  async listar(matriculaId: number): Promise<DescuentoEstudiante[]> {
    return httpClient.get<DescuentoEstudiante[]>(`/descuentos-estudiante/matricula/${matriculaId}`);
  },

  async asignar(payload: DescuentoEstudiantePayload): Promise<DescuentoEstudiante> {
    return httpClient.post<DescuentoEstudiante>('/descuentos-estudiante', payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/descuentos-estudiante/${id}`);
  },
};
